export default {
  VIDEO: 'video',
  CHANNEL: 'channel',
  USER_NAME: 'username',
  PLAYLIST: 'playlist',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/url-types.js